export enum EvalFilterFields {
  Status = 'status',
  Locations = 'locations',
  Managers = 'managers',
  Members = 'members',
  DateFrom = 'dateFrom',
  DateTo = 'dateTo',
  Departments = 'departments',
  IncludeRegular = 'includeRegular',
  IncludeEop = 'includeEop',
  EopStatus = 'eopStatus',
  IsRescheduled = 'isRescheduled',
  EopResolvedAtFrom = 'eopResolvedAtFrom',
  EopResolvedAtTo = 'eopResolvedAtTo',
  EopExtendedToFrom = 'eopExtendedToFrom',
  EopExtendedToTo = 'eopExtendedToTo',
  EmploymentType = 'employmentType',
  HasOngoingFlag = 'hasOngoingFlag',
  EngagementModels = 'engagementModels',
}
